import React from 'react';
import loader from "../../assets/images/loader.png";
import './loader.css';

function Loader() {
    return (
        <div className='loader-cont'>
            <img alt='Loader' className='loader-img' src={loader} />
        </div>
    );
}

export default Loader;